export default __webpack_public_path__ + "static/media/footer2.5e6ac0be.svg";